import { all, call, fork, put, takeLatest, select } from "redux-saga/effects";
import { API_GET } from "../../helpers/api";
import * as actions from "../actions/contracts";
import * as offerActions from "../actions/offers";
import {
  convertNumberToFrontend,
  convertAmountToFrontend,
} from "../../helpers/convert";
import {
  GET_ALL_CONTRACTS_REQUESTED,
  SET_ALL_CONTRACT_SELECTED,
} from "../types";

export const getContractFilters = (state) => state.contracts.filter;

function* watchGetAllContracts() {
  yield takeLatest(GET_ALL_CONTRACTS_REQUESTED, getAllContracts);
}
function* watchSetAllContractSelected() {
  yield takeLatest(SET_ALL_CONTRACT_SELECTED, getMarketMatches);
}

function* getAllContracts(action) {
  try {
    let filter = yield select(getContractFilters);
    const res = yield call(apiGetAllContracts, { filter, action });
    let contracts = res.data.items.reduce((acc, value) => {
      acc.push({
        id: value.id,
        contractName: value.contractName,
        bestBuyAmount: value.bestBuyAmount
          ? `${convertAmountToFrontend(
              value.bestBuyAmount
            )} - ${convertNumberToFrontend({
              num: value.bestBuyPrice,
              digit: 2,
            })}`
          : "0 - 0 TL",
        bestSpread: value.bestBuyPrice
          ? `${convertNumberToFrontend({
              num: Math.abs(value.bestBuyPrice - value.bestSellPrice),
              digit: 2,
            })}`
          : "0 TL",
        bestSellAmount: value.bestSellAmount
          ? `${convertAmountToFrontend(
              value.bestSellAmount
            )} - ${convertNumberToFrontend({
              num: value.bestSellPrice,
              digit: 2,
            })}`
          : "0 - 0 TL",
        maxMatchPrice: value.maxMatchPrice
          ? `${convertNumberToFrontend({ num: value.maxMatchPrice, digit: 2 })}`
          : "0 TL",
        minMatchPrice: value.minMatchPrice
          ? `${convertNumberToFrontend({ num: value.minMatchPrice, digit: 2 })}`
          : "0 TL",
        lastMatchAmount: value.lastMatchAmount
          ? convertAmountToFrontend(value.lastMatchAmount)
          : 0,
        lastMatchPrice: value.lastMatchPrice
          ? `${convertNumberToFrontend({
              num: value.lastMatchPrice,
              digit: 2,
            })}`
          : "0 TL",
        tradingVolume: value.totalAmount
          ? convertAmountToFrontend(value.totalAmount)
          : 0,
        weightedAverage: value.averagePrice
          ? `${convertNumberToFrontend({ num: value.averagePrice, digit: 2 })}`
          : "0 TL",
        status: value.status,
        contractEndTime: "",
        type: value.type,
        description: value.description,
      });
      return acc;
    }, []);
    yield put(
      actions.getAllContractsSucceeded({
        contracts,
        totalItemCount: res.data.totalItemCount,
        totalPageCount: res.data.totalPageCount,
      })
    );
  } catch (err) {
    yield put(actions.getAllContractsFailed());
  }
}

function* getMarketMatches(action) {
  yield put(
    offerActions.getMarketMatchesRequested({
      contractId: action.payload.contract.id,
      isMarketResult: action.payload.isMarketResult
    })
  );
}

export default function* contractSaga() {
  yield all([fork(watchGetAllContracts), fork(watchSetAllContractSelected)]);
}

function apiGetAllContracts(params) {
  return API_GET("system-parameter/contract/search", {
    sessionDate: params.filter.period
      ? params.filter.period.replace("-", "")
      : "",
    page: params?.action?.payload?.page || 0,
    size: 10,
  });
}
